type GHSPictogramProps = {
  code: string;
  size?: number;
};

const STROKE = "#7a2218";

function glyph(code: string) {
  const common = {
    stroke: STROKE,
    strokeWidth: 1.4,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    fill: "none",
  };
  switch (code) {
    case "GHS01":
      return (
        <g {...common}>
          <path d="M9 12l3-4 3 4-3 5z" />
          <path d="M7 16l1-1M16 16l1-1" />
        </g>
      );
    case "GHS02":
      return (
        <g {...common}>
          <path d="M12 6c2 2 0 3 0 5 0 1.5 1 3 3 3-1 2-3 3-5 3-3 0-5-2-5-4 0-2 2-3 3-5 1-1 1-1 1-2 2 1 2 0 3 0z" />
        </g>
      );
    case "GHS03":
      return (
        <g {...common}>
          <circle cx="12" cy="13" r="2" />
          <path d="M9 9l-1-2M15 9l1-2M12 7V5" />
        </g>
      );
    case "GHS04":
      return (
        <g {...common}>
          <rect x="9" y="7" width="6" height="10" rx="1" />
          <path d="M11 7V5h2v2" />
        </g>
      );
    case "GHS05":
      return (
        <g {...common}>
          <path d="M5 9h6l-2 4M19 9h-6l2 4" />
          <path d="M11 17h2" />
        </g>
      );
    case "GHS06":
      return (
        <g {...common}>
          <circle cx="10" cy="11" r="0.6" fill={STROKE} />
          <circle cx="14" cy="11" r="0.6" fill={STROKE} />
          <path d="M9 14h6l-1 3H10z" />
          <path d="M11 17v-1M13 17v-1" />
        </g>
      );
    case "GHS07":
      return (
        <g {...common}>
          <path d="M12 7v6" />
          <circle cx="12" cy="16" r="0.6" fill={STROKE} />
        </g>
      );
    case "GHS08":
      return (
        <g {...common}>
          <path d="M9 8a3 3 0 0 1 6 0v3a3 3 0 0 1-6 0z" />
          <path d="M11 14h2v3h-2zM12 17v2" />
        </g>
      );
    case "GHS09":
      return (
        <g {...common}>
          <path d="M5 15c2-1 4 1 7 0s4 1 7 0" />
          <path d="M5 17c2-1 4 1 7 0s4 1 7 0" />
          <path d="M11 8l1 4 1-4" />
        </g>
      );
    default:
      return null;
  }
}

export function GHSPictogram({ code, size = 48 }: GHSPictogramProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ display: "block" }}
    >
      <path
        d="M12 2 22 12 12 22 2 12z"
        fill="#fff"
        stroke="#c92619"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {glyph(code)}
    </svg>
  );
}
